import { baseApi } from './baseApi';

export const treatmentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listTreatmentTypes: build.query({
      query: () => '/treatment/types',
      transformResponse: (resp) => resp.data,
      providesTags: [{ type: 'TreatmentType', id: 'LIST' }],
    }),
    createTreatmentType: build.mutation({
      query: (body) => ({ url: '/treatment/types', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: [{ type: 'TreatmentType', id: 'LIST' }],
    }),
    listTreatmentPlans: build.query({
      query: (patientId) => `/treatment/plans/by-patient/${patientId}`,
      transformResponse: (resp) => resp.data,
      providesTags: (_r, _e, patientId) => [{ type: 'TreatmentPlan', id: patientId }],
    }),
    createTreatmentPlan: build.mutation({
      query: (body) => ({ url: '/treatment/plans', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, body) => [{ type: 'TreatmentPlan', id: body?.patientId }],
    }),
  }),
});

export const {
  useListTreatmentTypesQuery,
  useCreateTreatmentTypeMutation,
  useListTreatmentPlansQuery,
  useCreateTreatmentPlanMutation,
} = treatmentApi;
